<template>
  <div class="ui-seg" :class="{ 'ui-seg--block': block }" :role="tabs ? 'tablist' : 'group'" :aria-label="label || null" :aria-labelledby="labelledby || null">
    <button
      v-for="item in options"
      :key="String(item.value)"
      type="button"
      :role="tabs ? 'tab' : null"
      :aria-pressed="tabs ? null : String(value === item.value)"
      :aria-selected="tabs ? String(value === item.value) : null"
      :disabled="item.disabled || null"
      @click="$emit('input', item.value)"
    >
      <slot name="option" :option="item" :active="value === item.value">{{ item.label }}</slot>
    </button>
  </div>
</template>

<script>
/**
 * Segmentirani izbor (jedan od nekoliko). options: [{ value, label, disabled? }]; v-model. block rasteže dugmad preko cijele širine.
 * tabs: segment prebacuje prikaz na istoj stranici (role="tablist", dugmad role="tab" i aria-selected), inače je grupa dugmadi (aria-pressed).
 * Slot `option` ({ option, active }) mijenja sadržaj dugmeta (npr. značka ili broj).
 */
export default {
  name: "UiSegment",
  props: {
    value: { type: [String, Number, Boolean], default: "" },
    options: { type: Array, required: true },
    label: { type: String, default: "" },
    labelledby: { type: String, default: "" },
    block: { type: Boolean, default: false },
    tabs: { type: Boolean, default: false },
  },
};
</script>
